import React from "react";

function AssociatedPartners() {
    return (
        <div>
             <div className="mt-5">
                <div class="p-5">
                    <h6 class="display-6 text-center"><small>Associated Partners</small></h6>
                </div>
            </div>
        </div >
    );
}

export default AssociatedPartners;